<script>
  import { faFileCsv } from '@itdev-fortawesome/pro-solid-svg-icons/faFileCsv';
  import { faFileExcel } from '@itdev-fortawesome/pro-solid-svg-icons/faFileExcel';
  import { FontAwesomeIcon } from '@fortawesome/svelte-fontawesome';
</script>

<main class="container py-3" id="main-content">
  <h2>Reports</h2>
  <p>Download Excel or CSV reports</p>
  <div class="row row-cols-1 row-cols-md-2">
    <div class="col d-flex flex-column mb-3">
      <div class="card flex-grow-1">
        <div class="card-body d-flex flex-column gap-3">
          <div class="flex-grow-1">Download Excel workbook. Each data aggregation has its own worksheet.</div>
          <div class="d-grid">
            <a href="/api/reports/xlsx" class="btn btn-primary" target="_blank">
              <FontAwesomeIcon icon={faFileExcel} /> Download Excel
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="col d-flex flex-column mb-3">
      <div class="card flex-grow-1">
        <div class="card-body d-flex flex-column gap-3">
          <div class="flex-grow-1">
            Download CSV package. Each data aggregation is in a separate comma separated value file. Files are combined
            into a single ZIP archive.
          </div>
          <div class="d-grid">
            <a href="/api/reports/csv" class="btn btn-primary" target="_blank">
              <FontAwesomeIcon icon={faFileCsv} /> Download CSV
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</main>
